module.exports = __webpack_public_path__ + "static/media/2.dca051c4.jpg";